module.exports = __webpack_public_path__ + "static/Gibson-Light-webfont-38fe32e59be9d8ee6e2df6620e1d4f9c.eot";